<div class="flex-1 bd-object-search-results">
  @if (!store.searchResultsGlobalStoreProperties().searchResultsLoading) {
    @if (store.searchResultItems().length > 0) {
      <div class="bd-object-search-results-header-wrapper">
        <bd-object-search-results-header
          data-id="search-results-header"
          class="block bd-object-search-results-header"
          [isSelectionMode]="
            store.searchResultsGlobalStoreProperties().isSelectionMode
          "
          [showSelectAllButton]="objectResultsMode === 'list'"
          [totalSearchResultsCount]="totalSearchResultsCount"
          [numberOfSelectedItems]="store.numberOfSelectedItems()"
          [actions]="headerActions"
          [selectAllDisabled]="store.selectAllDisabled()"
          (selectionCanceled)="store.cancelSelection()"
          (selectAllClicked)="onSelectAllClick()"
        ></bd-object-search-results-header>
      </div>

      <div
        class="bd-object-search-results-body"
        [class.bd-drawer-open]="isDrawerOpen()"
        [style]="{
          height: 'calc(100vh - 100px - ' + filtersHeight + 'px)',
        }"
      >
        <div
          #searchResultItemsWrapper
          class="bd-object-search-results-items"
          [class.bd-table-mode]="objectResultsMode === 'table'"
          data-id="search-results"
        >
          @if (objectResultsMode === 'table') {
            <bd-object-search-results-table
              class="bd-object-search-results-content"
              [items]="store.searchResultItems()"
              [columnCatalogue]="columnCatalogue()"
              [layout]="tableLayout"
              [selection]="tableSelection()"
              [manageWorkspaceAccess]="tableManageWorkspaceAccess()"
              [currentSort]="currentSort"
              (openSearchResultItem)="onOpenSearchResultItem($event)"
              (deleteSearchResultItem)="deleteSearchResultItem.emit($event)"
              (selectedItemsChange)="onSelectedItemsChange($event)"
              (selectAllChange)="onSelectAllChange($event)"
              (openContentDetails)="onOpenContentDetails($event)"
              (itemSelectionToggled)="onItemSelectionToggled($event)"
              (sortChange)="onSortChange($event)"
            ></bd-object-search-results-table>
          } @else {
            @for (item of store.searchResultItems(); track item.id) {
              <bd-object-search-result-item
                class="bd-search-item"
                [attr.data-id]="'bd-search-item-' + item.id"
                [item]="item"
                [isSelectionMode]="
                  store.searchResultsGlobalStoreProperties().isSelectionMode
                "
                [selectedItems]="store.selectedItems()"
                [isActive]="item.id === activeItemId() && isDrawerOpen()"
                [manageWorkspaceActionDisabled]="
                  manageWorkspaceActionDisabled()
                "
                [manageWorkspaceNoAccessTooltip]="
                  manageWorkspaceNoAccessTooltip()
                "
                (openSearchResultItem)="onOpenSearchResultItem($event)"
                (deleteSearchResultItem)="deleteSearchResultItem.emit($event)"
                (selectedItemsChange)="onSelectedItemsChange($event)"
                (openContentDetails)="onOpenContentDetails($event)"
                (itemSelectionToggled)="onItemSelectionToggled($event)"
              ></bd-object-search-result-item>
            }
          }
        </div>
        @if (
          totalSearchResultsCount >
          store.searchResultsGlobalStoreProperties().pageSize
        ) {
          <div class="bd-pagination-wrapper">
            <bd-pagination
              class="bd-pagination"
              data-id="results-page"
              [currentPage]="
                store.searchResultsGlobalStoreProperties().currentPageIndex + 1
              "
              [totalRecords]="totalSearchResultsCount"
              [pageSize]="store.searchResultsGlobalStoreProperties().pageSize"
              [paginationType]="'regular'"
              (currentPageChange)="onPageChange($event)"
            ></bd-pagination>
          </div>
        }
      </div>
    } @else {
      <div class="bd-call-to-action-wrapper">
        <bd-search-tab-empty-state
          class="bd-object-search-results-content"
          data-id="no-results-found"
          [titleKey]="'featureSearch.tabEmptyState.noObjectsTitle'"
          [descriptionKey]="'featureSearch.tabEmptyState.noObjectsDescription'"
          [links]="emptyStateLinks"
          [actionButton]="{
            labelKey: aiSearchActive
              ? 'noResults.clearFilters'
              : 'noResults.reviewAppliedFilters',
            tScope: 'featureSearch',
            onClick: aiSearchActive ? clearFilters : reviewAppliedFilters,
          }"
          (scopeSelected)="switchScope.emit($event)"
        ></bd-search-tab-empty-state>
      </div>
    }
  } @else {
    <div
      class="bd-object-search-results-loading-wrapper"
      [style]="{
        height: 'calc(100vh - 100px - ' + filtersHeight + 'px)',
      }"
    >
      <bd-object-search-results-loading></bd-object-search-results-loading>
    </div>
  }
</div>
